import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import {
  MenuState,
  ChangeTitleAction,
  InitializeTabsAction,
  TabTemplate,
} from './types';
import { tabLevel, TabKeys, tabType } from 'app/components/Tabs/constants';

export const initialState: MenuState = {
  siteTitle: 'Predictor Provisioning Tool',
  tabs: [],
};

const slice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    changeTitle(state, action: PayloadAction<ChangeTitleAction>) {
      state.siteTitle = action.payload.siteTitle;
    },
    initializeTabs(state, action: PayloadAction<InitializeTabsAction>) {
      state.tabs = TABS_SELECTOR(action.payload.type, action.payload.id);
    },
    destroyTabs(state) {
      state.tabs = [];
    },
  },
});

export const { actions: menuActions, reducer: menuReducer } = slice;

export const useMenuSlice = () => ({ actions: slice.actions });

export const TABS_SELECTOR = (type: tabLevel, id: string): TabTemplate[] => {
  switch (type) {
    case 'user':
    case 'subscription':
      return getTabsFor(id, type);
    default:
      return [];
  }
};

export const getTabsFor = (id: string, type: tabLevel): TabTemplate[] => {
  return Object.keys(TabKeys[type]).map((key: string) => {
    // const typeOfTab = TabKeys[type][key].type;
    // if (typeOfTab === tabType.normal) { TODO: Add back when having other tabType
    return {
      type: tabType.normal,
      tabs: [
        {
          key: key,
          name: TabKeys[type][key].value as string,
          path: `/${type}/${id}/${key}`,
        },
      ],
    };
    // }
  });
};
